<template>
  <section>
    <p class="pt-1 pb-4 text-gray-400 font-md">
      {{ $t(`manageplan.component.modal.planDetail.description`) }}
    </p>

    <ul class="d-flex flex-column p-0" v-if="planFeatures.length">
      <li
        v-for="(feature, index) in planFeatures"
        :key="feature.title"
        :class="{ 'bg-gray-200': index / 2 == 0 }"
        class="d-flex justify-content-between p-3 px-4 bg-white"
      >
        <span class="w-50 font-weight-bold">{{ feature.title }}</span>
        <span class="w-50" v-if="feature.description"> {{ feature.description }} </span>
        <span class="w-50 text-primary" v-if="feature.isChecked == true">
          <CIcon class="check mr-2" name="checkMark" :height="15" viewBox="0 0 32 32" />
        </span>
        <span class="w-50 text-gray-400" v-if="feature.isChecked == false">
          <CIcon class="refused mr-2" name="cross" :height="14" viewBox="0 0 32 32" />
        </span>
      </li>
    </ul>

    <div class="d-flex justify-content-center">
      <CButton @click="setModal(null)" class="px-5 py-2 mt-3 btn-outline-primary w-50 py-3"> Close x</CButton>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ModalPlanDetail',
  computed: {
    features() {
      return [
        {
          planName: 'Starter',
          features: [
            {
              title: 'Platform Users',
              description: '1 users',
              isChecked: null,
            },
            {
              title: 'Included E-mails',
              description: this.$store.state.backOffice.steps.maxEmailsIncluded + ' e-mails/month',
              isChecked: null,
            },
            {
              title: 'Sub Accounts',
              description: '1 account',
              isChecked: null,
            },
            {
              title: 'Flexible Import - Contact Lists',
              description: null,
              isChecked: true,
            },
            {
              title: 'Audience Segmentation',
              description: null,
              isChecked: true,
            },
            {
              title: 'Integrated Customer Profile',
              description: null,
              isChecked: true,
            },
            {
              title: 'Multichannel Campaign Editor',
              description: null,
              isChecked: true,
            },
            {
              title: 'Campaign Template',
              description: '3',
              isChecked: null,
            },
            {
              title: 'Templates Premium',
              description: null,
              isChecked: false,
            },
            {
              title: 'HTML Template Import',
              description: null,
              isChecked: false,
            },
            {
              title: 'Campaign Dashboard and Statistics',
              description: null,
              isChecked: true,
            },
            {
              title: 'Automation Flows',
              description: '1',
              isChecked: null,
            },
            {
              title: 'Customer Support',
              description: 'E-mail Support (Business Hours with priority)',
              isChecked: null,
            },
          ],
        },
        {
          planName: 'Professional',
          features: [
            {
              title: 'Platform Users',
              description: '3 users',
              isChecked: null,
            },
            {
              title: 'Included E-mails',
              description: this.$store.state.backOffice.steps.maxEmailsIncluded + ' e-mails/month',
              isChecked: null,
            },
            {
              title: 'Sub Accounts',
              description: '10 accounts', //this.$store.state.backOffice.steps.maxEmailsIncluded
              isChecked: null,
            },
            {
              title: 'Flexible Import - Contact Lists',
              description: null,
              isChecked: true,
            },
            {
              title: 'Audience Segmentation',
              description: null,
              isChecked: true,
            },
            {
              title: 'Integrated Customer Profile',
              description: null,
              isChecked: true,
            },
            {
              title: 'Multichannel Campaign Editor',
              description: null,
              isChecked: true,
            },
            {
              title: 'Campaign Template',
              description: '10',
              isChecked: null,
            },
            {
              title: 'Templates Premium',
              description: null,
              isChecked: true,
            },
            {
              title: 'HTML Template Import',
              description: null,
              isChecked: true,
            },
            {
              title: 'Campaign Dashboard and Statistics',
              description: null,
              isChecked: true,
            },
            {
              title: 'Automation Flows',
              description: '5',
              isChecked: null,
            },
            {
              title: 'Customer Support',
              description: 'E-mail Support (Business Hours with priority)',
              isChecked: null,
            },
          ],
        },
        {
          planName: 'Business',
          features: [
            {
              title: 'Platform Users',
              description: 'Up to 10 users',
              isChecked: null,
            },
            {
              title: 'Included E-mails',
              description: this.$store.state.backOffice.steps.maxEmailsIncluded + ' e-mails/month',
              isChecked: null,
            },
            {
              title: 'Sub Accounts',
              description: 'Up to 25 accounts',
              isChecked: null,
            },
            {
              title: 'Flexible Import - Contact Lists',
              description: null,
              isChecked: true,
            },
            {
              title: 'Audience Segmentation',
              description: null,
              isChecked: true,
            },
            {
              title: 'Integrated Customer Profile',
              description: null,
              isChecked: true,
            },
            {
              title: 'Multichannel Campaign Editor',
              description: null,
              isChecked: true,
            },
            {
              title: 'Campaign Template',
              description: 'Unlimited',
              isChecked: null,
            },
            {
              title: 'Templates Premium',
              description: null,
              isChecked: true,
            },
            {
              title: 'HTML Template Import',
              description: null,
              isChecked: true,
            },
            {
              title: 'Campaign Dashboard and Statistics',
              description: null,
              isChecked: true,
            },
            {
              title: 'Automation Flows',
              description: 'Up to 25',
              isChecked: null,
            },
            {
              title: 'Customer Support',
              description: 'E-mail & Phone Support (Business Hours Top Priority)',
              isChecked: null,
            },
          ],
        },
        {
          planName: 'PayAsYouGo',
          features: []
        }
      ]
    },
    planFeatures() {
      let planName = this.$store.state.backOffice.steps.selectedPlanName

      if (this.features.length && planName) {
        let featuresPlan = this.features.filter((item) => item.planName.toUpperCase() == planName.toUpperCase())[0].features || []
        //featuresPlan.features.description = 'Hassan'
        return featuresPlan
      }

      return []
    },
  },

  methods: {
    setModal() {
      this.$store.dispatch('backOffice/steps/setModalComponent', { modalName: '', componentName: '' })
    },
  },
}
</script>

<style lang="scss"></style>
